// Module
var code = `<div appHeaderBar>
    <header-bar-title>Make A Payment</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <app-cobrand-header [property]="paymentRequest.property.nickname"
                        [manager]="paymentRequest.property.hoa.pmc.name"
                        [association]="paymentRequest.property.hoa.name"
                        [makePayment]="true">
    </app-cobrand-header>

    <div class="HOA-misc-guidedSteps__container">
        <div class="HOA-container__header">
            <!-- TODO: Add blue line and header formatting -->
            <div class="HOA-container__header-text" tid="pageTitle" id="pageTitle">One-Time Payment Summary</div>
        </div>
        <div class="HOA-container__content HOA-misc-guidedSteps__flex-extra-padded">
            <div class="HOA-flex-component HOA-make-payment-item-row">
                <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold">Property Address</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight">
                    <div>
                        <span tid="addressLine1" id="addressLine1">
                            {{paymentRequest.property.address.line1}}
                        </span>
                        <br>
                        <span tid="addressLine2" id="addressLine2">
                            {{paymentRequest.property.address.line2}}
                        </span>
                    </div>
                    <div>
                        <span tid="city" id="city">{{paymentRequest.property.address.city}}</span>,
                        <span tid="state" id="state">{{paymentRequest.property.address.state}}</span>
                        <span tid="postalCode" id="postalCode">
                            {{paymentRequest.property.address.postalCode}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="HOA-flex-component u-pT2 HOA-make-payment-item-row">
                <div class="HOA-flex-component HOA-misc-guidedSteps__flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold u-pR1">Payment Date</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight">
                    <span tid="paymentDate" id="paymentDate">
                        {{paymentRequest.paymentDate.formattedFullDate}}
                    </span>
                </div>
            </div>
            <div class="HOA-flex-component HOA-make-payment-item-row">
                <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold">Payment Method</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight">
                    <span tid="paymentMethod" id="paymentMethod">{{paymentRequest.paymentMethod.nickname}}</span>
                    (<span tid="maskedId" id="maskedId">{{paymentRequest.paymentMethod.maskedId}}</span>)
                </div>
            </div>
            <div class="HOA-flex-component HOA-make-payment-item-row"
                 *ngFor="let due of filteredDues(paymentRequest.payment['dues'])">
                <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold">{{(due.name) ? due.name : 'Amount'}}</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight">
                    <span tid="paymentAmount" id="paymentAmount">{{due.amount | currency}}</span>
                </div>
            </div>
            <!--Payment Details-->
            <div *ngIf="paymentRequest.details" class="HOA-flex-component HOA-make-payment-item-row">
                <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold">Items</span>
                </div>
            </div>
            <div class="HOA-flex-component HOA-make-payment-item-row u-pL5"
                 *ngFor="let cartItem of paymentRequest.details">
                <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width">
                    <span class="">{{cartItem.description}}</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight">
                    <span tid="cartItemAmount" id="cartItemAmount">
                        {{cartItem.amount * cartItem.qty | currency}}
                    </span>
                </div>
            </div>
            <!--Administrative Fee-->
            <div class="HOA-flex-component HOA-make-payment-item-row">
                <div class="HOA-flex-component HOA-misc-guidedSteps__flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold">Administrative Fee</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight">
                    <span tid="feeAmount" id="feeAmount">{{paymentRequest.payment.feeAmount | currency}}</span>
                </div>
            </div>
            <!--Total-->
            <div class="HOA-flex-component HOA-make-payment-item-row">
                <div class="HOA-flex-component HOA-misc-guidedSteps__flex-align HOA-make-payment-fancy-width">
                    <span class="u-fontBold u-pR1">Total Amount</span>
                </div>
                <div class="HOA-make-payment-item-row-amount u-textRight">
                    <span tid="totalPaymentAmount" id="totalPaymentAmount"
                          class="HOA-make-payment-amount-total">
                        {{paymentRequest.payment.totalPaymentAmount | currency}}
                    </span>
                </div>
            </div>

            <input type="checkbox"
                   id="tcCheckbox"
                   name="tcCheckbox"
                   tid="tcCheckbox"
                   class="Field u-cf"
                   style="margin-bottom: 26px; accent-color: #00505c"
                   [(ngModel)]="tcCheckbox"
                   [ngClass]="{'is-invalid': false}">
            <label for="tcCheckbox" class="HOA-font-light"> I agree to pay the total amount due including administrative fees. </label>

            <div class="HOA-flex-component HOA-flextable-component__flex-end">
                <button name="cancel"
                        id="cancel"
                        tid="cancel"
                        type="button"
                        class="Button Button--link HOA-make-payment-button"
                        (click)="navigateToPropertiesDummy()">
                    Back
                </button>
                <button name="submit"
                        id="submit"
                        tid="submit"
                        [disabled]="!tcCheckbox || disableSubmitBtn"
                        type="submit"
                        class="Button Button--blue"
                        ifOverFlowXClass="Button--overflowX"
                        (click)="submit()">
                    Submit Payment
                </button>
            </div>
            <span class="HOA-Field-detail HOA-make-payment-disclaimer">
                Payments are processed Monday through Friday, excluding holidays.
                Payments submitted on weekends or holidays may be delayed.</span>
        </div>
    </div>
</app-page-content>
`;
// Exports
module.exports = code;